import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NoteComponent } from 'common-ui';

@Component({
  selector: 'ideal-product-hero-header',
  imports: [NoteComponent],
  templateUrl: './product-hero-header.component.html',
  styleUrl: './product-hero-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductHeroHeaderComponent {}
